<template>
  <div class="page-content">
    <page-template ref="scalesTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
    ></page-template>
    <el-dialog title="商城商品档案" :visible.sync="batchEditShow" width="1200px" height="800"
               :close-on-click-modal="false">
      <batch-modification ref="infoGoods" :isSelect="goodEditListSelect" :tableOptions="batchTableOptions"
                          :batchUpData="batchUpDateList" :dataList="dataList"
      ></batch-modification>
      <div class="btn-box">
        <el-button @click="selectSubmit" type="primary">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import batchModification from '@/components/business/batchModification'

export default {
  components: {
    pageTemplate,
    batchModification
  },
  data() {
    return {
      goodEditListSelect: true,
      batchEditShow: false,
      batchUpDateList: [],
      dataList: [],
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: '商品名称/条码',
            type: 'input',
            prop: 'otherName',
            placeholder: '请输入商品名称/条码',
            isFuzzy: true
          },
        ],
        complex: [
          {
            label: '选择日期:',
            prop: 'createDttms',
            type: 'datetimeRange',
            dateType: 'date',
            span: 24
          },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert',
          callback: this.addGoods
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate,
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {label: '商品条码', prop: 'barCode', width: '190', align: 'center'},
          {label: '条码', prop: 'artNo', width: '190', align: 'center'},
          {label: '商品名称', prop: 'goodsName', width: '190', align: 'center'},
          {label: '加入推荐时间', prop: 'lastModifyDttm', width: '190', align: 'center'},
          {label: '零售价', prop: 'retailPrice', width: '120', align: 'center'},
          {label: '商城价', prop: 'mallRetailPrice', width: '120', align: 'center'},
          {label: '排序', prop: 'orderNo', width: '120', align: 'center'},
          {
            label: '商品状态',
            prop: 'status',
            width: '120',
            align: 'center',
            enumData: this.$utils.getCacheStatus("mallGoodsNow.status")
          },
        ],
        url: api.mall.newGoods
      },
      //添加
      batchTableOptions: {
        columns: [
          {label: '商品名称', prop: 'goodsName', width: '190', align: 'center'},
          {label: '商品条码', prop: 'barCode', width: '190', align: 'center'},
          {label: '条码', prop: 'artNo', width: '190', align: 'center'},
          {label: '零售价', prop: 'retailPrice', width: '120', align: 'center'},
          {label: '商城价', prop: 'mallRetailPrice', width: '120', align: 'center'},
          {label: '排序', prop: 'orderNo', width: '120', align: 'center', type: "inputNumber"},
        ],
        param: {openMall: true},
        url: api.archives.goodsInfoIncludeSpecs
      },
    };
  },
  created() {
    this.getNewList();
  },
  methods: {
    addGoods() {
      this.batchEditShow = true;
      this.$nextTick(() => {
        this.$refs["infoGoods"].getTableData();
      })
    },
    selectSubmit() {
      let goodsArray = this.$refs['infoGoods'].tabelSelectRows;
      if (goodsArray.length === 0) {
        this.$message({message: "请勾选商品后进行操作！", type: "warning"});
      } else {
        this.$axios.fetchPost(api.mall.newGoods, {goodsList: goodsArray})
          .then(data => {
            this.loading = false;
            if (data.code == 200 && data.data) {
              this.batchEditShow = false;
              this.getNewList();
              this.$refs['scalesTemplate'].operationSuccess();
            } else {
              this.$message({message: "请求失败！", type: "error"});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: "请求失败！", type: "error"});
            this.loading = false;
          });
      }
    },
    getNewList() {
      this.$axios.fetchPost(api.mall.newGoods + '/list').then(data => {
        if (data.code === 200) {
          this.dataList = data.data;
        }
      });
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/mall/marketing/Now.vue